const LEGACY_APPLICATION_QUESTIONS = [
  {
    key: "noticePeriod",
    titleId: "Missions.MissionRole.ApplyForm.TimeBeforeStarting",
    answerId: (value) => `MissionRoleApplicant.NoticePeriod.${value}`,
  },
  {
    key: "availablePartTimeDuringNotice",
    titleId: "Missions.MissionRole.ApplyForm.AvailablePartTimeDuringNotice",
    answerId: (value) => `MissionRoleApplicant.QuestionnaireResponseBox.PartTimeDuringNotice.${value}`,
  },
];

/**
 * @param {Object} missionRoleApplicant
 *
 * @returns {Array} The legacy questions this applicant answered
 */
const getAnsweredLegacyQuestions = (missionRoleApplicant) =>
  LEGACY_APPLICATION_QUESTIONS.filter(({ key }) => missionRoleApplicant?.[key] != null);

/**
 * @param {Object} missionRoleApplicant
 * @param {Array}  questions             The role's assessment questions
 *
 * @returns {Array} `{ number, legacyQuestion }` or `{ number, question }`, answered legacy questions first
 */
const getApplicationQuestionnaireItems = (missionRoleApplicant, questions = []) =>
  [
    ...getAnsweredLegacyQuestions(missionRoleApplicant).map((legacyQuestion) => ({ legacyQuestion })),
    ...questions.map((question) => ({ question })),
  ].map((item, index) => ({ ...item, number: index + 1 }));

export { getApplicationQuestionnaireItems };
